import { CheckMarkIcon } from '@braskai/icons';
import { Typography, useDeviceType } from '@braskai/ui-kit';

import { Divider, Stack } from '@mui/material';

// Figma: background/badge/blue-disabled.
const BANNER_BACKGROUND = '#f0f4fe';

const ADVANTAGES = [
  'No minutes lost at month end',
  'Buy additional minutes anytime',
  'Unlimited re-editing and redubbing',
];

export const YearlyAdvantages = () => {
  const { isMobile } = useDeviceType();

  return (
    <Stack
      sx={{
        backgroundColor: BANNER_BACKGROUND,
        border: '1px solid',
        borderColor: 'grey.200',
        borderRadius: 16,
        paddingX: 16,
        paddingY: 24,
        width: '100%',
      }}
      alignItems={isMobile ? 'stretch' : 'center'}
      gap={16}
    >
      <Typography color="primary.700" variant="body-2-md">
        YEARLY PLANS ONLY
      </Typography>
      <Stack
        divider={
          isMobile ? undefined : (
            <Divider
              orientation="vertical"
              sx={{ alignSelf: 'center', borderColor: 'grey.300', height: 24 }}
              flexItem
            />
          )
        }
        alignItems={isMobile ? 'flex-start' : 'center'}
        direction={isMobile ? 'column' : 'row'}
        gap={isMobile ? 8 : 32}
        justifyContent="center"
      >
        {ADVANTAGES.map((advantage) => (
          <Stack key={advantage} alignItems="center" direction="row" gap={8} sx={{ color: 'primary.700' }}>
            <CheckMarkIcon height={20} width={20} />
            <Typography color="primary.700" variant="body-2-md">
              {advantage}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};
